import { useSearchParams } from 'react-router';

export const Redirect = () => {
  const [searchParams] = useSearchParams();
  const redirectQueryParam = searchParams.get('redirectUrl');
  if (redirectQueryParam) {
    window.location.replace(redirectQueryParam);
  } else {
    history.back();
  }
  return null;
};
